import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getMediosPago,
  getGatewayPago,
} from '../../core/pagos/pagos-actions.js';
import MercadoPagoGateway from '../../core/classes/MercadoPagoGateway';
import DecidirGateway from '../../core/classes/DecidirGateway';
import { getFullUrl } from '../../core/globals';
import loadEpagos from '../Pagos/Epagos/epagosLib';
import { reNombre, reIntegerPos } from '../../core/expRegulares.js';
import { formatMoneda } from '../../core/helpers.js';

import Grid from '@material-ui/core/Grid';
import GridItem from '../../components/Grid/GridItem.jsx';
import InputLabel from '@material-ui/core/InputLabel';
import CustomInput from '../../components/CustomInput/CustomInput.jsx';
import FormControl from '@material-ui/core/FormControl';
import Button from '../../components/Buttons/Button.jsx';
import Select from '@material-ui/core/Select';
import MessageComponent from '../../components/Message/MessageComponent';
import BlockComponent from '../../components/Loading/BlockComponent';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Link from '@material-ui/core/Link';
import Datetime from 'react-datetime';
import 'moment/locale/es';
import { Modal, Typography } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    minWidth: 150,
    marginTop: 10,
  },
  selectEmpty: {
    marginTop: 2,
  },

  dense: {
    marginTop: 2,
  },
  menu: {
    width: 200,
  },
  p360ModalOverlayWrapper: {
    width: '50%',
    height: '50%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
  },
  p360ModalOverlay: {
    position: 'fixed',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    opacity: '0.3',
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
  },
  p360ModalContentFixed: {
    height: '34rem',
    maxHeight: '90%',
    width: '25rem',
    maxWidth: '90%',
    top: '50%',
    left: '50%',
    position: 'fixed',
    overflow: 'hidden',
    borderRadius: '6px',
    border: '1px solid #999',
    boxShadow: '-5px 5px 15px 0 rgba(0, 0, 0, .2)',
    webkitBorderRadius: '6px',
    transform: 'translate(-50%, -50%)',
    msTransform: 'translate(-50%, -50%)',
    webkitTransform: 'translate(-50%, -50%)',
  },
  p360ModalPopbox: {
    border: '0',
    width: '100%',
    height: '100%',
  },
  linkPagar: {
    color: '#fff',
    width: '100%',
    border: 'none',
    backgroundColor: theme.palette.primary.main,
    fontSize: '12px',
    height: '100%',
    minHeight: 'auto',
    lineHeight: '1.42857143',
    borderRadius: '3px',
    padding: '12px 30px',
    margin: '.3125rem 1px',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
      opacity: '0.9',
      backgroundColor: theme.palette.primary.light,
    },
  },
  divEpagos: {
    color: '#fff',
    width: '100%',
    border: 'none',
    fontSize: '12px',
    lineHeight: '1.42857143',
    borderRadius: '3px',
    margin: '.3125rem 1px',
  },
});

const MEDIOS_PAGO = {
  MERCADOPAGO: 'mercadopago',
  DECIDIR: 'decidir',
  REPORTE: 'reporte',
  INTERBANKING: 'interbanking',
  LINK: 'link',
  PAGOS360: 'pagos360',
  MACROCLICK: 'macroclick',
  MERCADOPAGOCH: 'mercadopagoch',
  PAGOSTIC: 'pagostic',
  EPAGOS: 'epagos',
  SUPERVIELLE: 'supervielle',
  BPN: 'bpnpagos',
}

const VerGateway = (
  { medioPago, cod_gateway, importe, fecha, payment360,
    paymentMacroClick, paymentMercadoPago, paymentPagosTic, paymentEpagos,
    email, paymentSupervielle, paymentBPN, cardholderName, id_operacion,
    handlerVolver, handlerPagar, bindDateValue, ...rest }) => {
  const rootRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    email: email,
    cardNumber: undefined,
    securityCode: undefined,
    cardExpirationMonth: undefined,
    cardExpirationYear: undefined,
    cardholderName: cardholderName,
    docType: undefined,
    docNumber: undefined,
    installments: "1",
    street_name: undefined,
    street_number: undefined,
    zip_code: undefined,
    customer_cuit_number: undefined,
    customer_name: undefined,
  });
  const [disablePagar, setDisablePagar] = useState(false);
  const [gatewayConfig, setGatewayConfig] = useState({
    gateway: null,
    tiposDocumento: null,
    gatewayReady: false,
  });
  const [infoMedioPago, setInfoMedioPago] = useState(null);
  const [opcionesCuotas, setOpcionesCuotas] = useState(null);
  const [bin, setBin] = useState(null);
  const [errores, setErrores] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [showButtonClose, setShowButtonClose] = useState(false);

  const dispatch = useDispatch();

  const [message, setMessage] = useState({
    message: null,
    messageColor: null,
  });
  const messageHelper = {
    setMessage: function(msg, color) {
      setMessage({ message: msg, messageColor: color });
      setTimeout(messageHelper.resetMessage, 6000);
    },
    setErrorMessage: function(msg) {
      messageHelper.setMessage({ message: msg, messageColor: 'error'});
    },
    resetMessage: function () {
      setMessage({ message: null, messageColor: null})
    }
  }

  const { classes } = rest;

  const scrollToTop = () => {
    rootRef.current.scrollIntoView({
      block: 'start',
    });
  };

  useEffect(() => {
    if (!gatewayConfig.gatewayReady) {
      Promise.resolve(
        dispatch(getGatewayPago({
          codGateway: cod_gateway,
        }))
      )
        .then((response) => {
          let public_key = null;
          let gateway = null;
          const medio = response[0];
          switch (medio.clase) {
            case MEDIOS_PAGO.MERCADOPAGO:
              public_key = response[0].public_key;
              gateway = new MercadoPagoGateway(public_key);
              inicializarGateway(gateway);
              break;

            case MEDIOS_PAGO.DECIDIR:
              public_key = response[0].public_key;
              gateway = new DecidirGateway(
                public_key,
                response[0].parametros.isProduccion || false
              );
              inicializarGateway(gateway);

              break;

            case MEDIOS_PAGO.REPORTE:
              if (
                medioPago.formulario !== 'no_form' &&
                medioPago.actualiza_fecha === 'N'
              ) {
                handlerPagar({
                  id_operacion: id_operacion,
                  medio_pago: medioPago.cod_medio_pago,
                });
              } else {
                setLoading(false);
              }

              break;

            case MEDIOS_PAGO.INTERBANKING:
              setLoading(false);
              break;
            case MEDIOS_PAGO.LINK:
              setLoading(false);
              break;
            case MEDIOS_PAGO.PAGOS360:
              setLoading(false);
              break;
            case MEDIOS_PAGO.MACROCLICK:
              setLoading(false);
              break;
            case MEDIOS_PAGO.MERCADOPAGOCH:
              setLoading(false);
              break;
            case MEDIOS_PAGO.PAGOSTIC:
              setLoading(false);
              break;
            case MEDIOS_PAGO.EPAGOS: {
              let parametros = {};
              try {
                parametros = JSON.parse(medio.parametros_str);
              } catch (e) {
                console.log('El json de parametros esta mal armado');
                handlerVolver();
                break;
              }
              let epagos = parametros;

              const script = document.createElement('script');
              const script_url = epagos?.script_url ? epagos.script_url : 'https://api.epagos.com.ar/quickstart/epagos.js';
              script.src = script_url;
              script.id = 'epagos_lib';

              document.body.appendChild(script);
              script.onload = () => {
                setLoading(false);
                const error_url = `${epagos.error_url}&numero_operacion=${id_operacion}`;
                window.ePagos.setClavePublica(medio.public_key);
                window.ePagos.setOrganismo(epagos.organismo);
                window.ePagos.setAmbiente(epagos.ambiente);

                const operacion= {
                  datosOperacion: {
                    convenio: epagos.convenio,
                    ok_url:  epagos.ok_url,
                    error_url:  epagos.error_url,
                    monto_operacion:  importe,
                    numero_operacion:  id_operacion,
                    identificador_externo_2:  paymentEpagos.identificador_externo_2,
                    opc_descargar_pdf: 1,
                    opc_fecha_vencimiento: paymentEpagos.fecha_vto,
                    detalle_operacion: paymentEpagos.detalle_operacion,
                    detalle_operacion_visible: paymentEpagos.detalle_operacion_visible,
                  }
                }
                window.ePagos.botonPago(operacion);
              }
              break;
            }
            case MEDIOS_PAGO.SUPERVIELLE: {
              setLoading(false);
              break;
            }
            case MEDIOS_PAGO.BPN: {
              setLoading(false);
              break;
            }
            default:
              console.log('Gateway de Pago no disponible.');
              handlerVolver();
              break;
          }

          scrollToTop();
        })
        .catch((error) => {
          messageHelper.setErrorMessage(error.message);
        });
    }
  }, []);

  const inicializarGateway = (gateway) => {
    gateway.inicializar(() => {
      gateway.tiposDocumento((data) => {
        setGatewayConfig({
          ...gatewayConfig,
          tiposDocumento: data,
          gateway: gateway,
          gatewayReady: true,
        });
        setLoading(false);
      });
    });
  };

  const getBin = () => {
    const cardnumber = formData.cardNumber || '';
    return cardnumber.replace('/ /g', '').substring(0, 6);
  };

  const bindValue = (key) => {
    return {
      onChange: handleOnChangeValue(key),
      value: formData[key] || '',
    };
  };

  const getMetodoPago = () => {
    const new_bin = getBin();

    if ((bin == null || bin !== new_bin) && new_bin.length >= 6) {
      setBin(new_bin);

      gatewayConfig.gateway.medioPago(
        {
          bin: new_bin,
        },
        (status, response) => {
          if (status === 200) {
            setInfoMedioPago(response);
          }
        }
      );
      gatewayConfig.gateway.getInstallments(new_bin, importe, (data) => {
        setOpcionesCuotas(data[0].payer_costs);
      });
    }
  };

  const getItemValue = (key) => {
    return formData[key] || '';
  };

  const bindNumberValue = (key) => {
    return {
      onChange: handleOnChangeValue(key),
      value:
        formData[key] === undefined
          ? 0
          : Number(formData[key] || ''),
    };
  };

  const handleOnChangeValue = (key) => {
    if (validateNumber(key))
      return (e) => {
        setFormData({
          ...formData,
          [key]: e.target.value,
        });
      };
  }

  const validate = (values) => {
    const errors = {};
    if (
      medioPago.formulario === 'decidir_tarjeta' ||
      medioPago.formulario === 'mercadopago_tarjeta'
    ) {
      if (!values.email || values.email.length < 1) errors.email = 'Verifique los datos.';
      if (!values.cardNumber) {
        errors.cardNumber = 'Verifique los datos.';
      } else {
        if (!validarCardNumber(values.cardNumber)) {
          errors.cardNumber = 'Número incorrecto.';
        }
      }

      if (!values.securityCode) errors.securityCode = 'Verifique los datos.';
      if (!values.cardExpirationMonth)
        errors.cardExpirationMonth = 'Verifique los datos.';
      if (!values.cardExpirationYear)
        errors.cardExpirationYear = 'Verifique los datos.';
      if (!validarCardHolderName(values.cardholderName))
        errors.cardholderName = 'Campo incorrecto.';
      if (!values.docType) errors.docType = 'Verifique los datos.';
      if (!values.docNumber) errors.docNumber = 'Verifique los datos.';
      if (!values.installments) errors.installments = 'Verifique los datos.';
    }

    if (medioPago.formulario === 'decidir_banelco') {
      if (!values.customer_doc_type)
        errors.customer_doc_type = 'Verifique los datos.';
      if (!values.customer_doc_number)
        errors.customer_doc_number = 'Verifique los datos.';
      if (!values.customer_name) errors.customer_name = 'Verifique los datos.';
    }

    return errors;
  };

  const validateNumber = (e) => {
    return true;
  };

  const validarCardHolderIdentificationNumber = (value) => {
    return !!value && !!reIntegerPos.test(value);
  };

  const validarCardHolderName = (value) => {
    return !!value && reNombre.test(value);
  };

  const validarCardNumber = (value) => {
    return value.toString().length === medioPago.parametros.longitud_pan;
  };

  const habilitarButtonPagar = () => {
    return true;
  };

  //onSelectTipoDocumento = (tipoDocumento) => {
  //  this.setState({ _tipoDocumento: tipoDocumento });
  //};

  const onVolver = (e) => {
    handlerVolver();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const errorList = validate(formData);

    if (Object.keys(errorList).length >= 1) {
      setErrores(errorList);
      setLoading(false);
      return;
    }

    if(medioPago.clase === MEDIOS_PAGO.INTERBANKING) {
      handlerPagar({
        id_operacion: id_operacion,
        medio_pago: medioPago.cod_medio_pago,
        cuit_number: formData['customer_cuit_number'],
        razon_social: formData['customer_name'],
      });
    }
    else {
      const payer_address = {
        street_name: formData['street_name'],
        street_number: formData['street_number'],
        zip_code: formData['zip_code'],
      };

      const payment_method_id = infoMedioPago[0].id;
      const installments = formData['installments'] || 1;
      gatewayConfig.gateway.tokenizar(
        formData,
        medioPago,
        (status, data) => {
          if (status !== 200 && status !== 201) {
            setLoading(false);
            return messageHelper.setErrorMessage(data.error);
          }
          handlerPagar({
            id_operacion: id_operacion,
            medio_pago: medioPago.cod_medio_pago,
            payment_method_id: payment_method_id,
            installments: installments,
            token: data,
            address: payer_address,
          });
        }
      );
    }
  };

  const campoFecha = ({
    timeFormat = false, dateFormat = 'DD/MM/YYYY', helpText, error, disabled,
    required
  } = {}) => {

    const yesterday = Datetime.moment().subtract(1, 'day');
    const valid = (currentDate) => {
      return currentDate.isAfter(yesterday);
    };

    return (
      <>
        <InputLabel
          style={{ float: 'left', paddingTop: '10px' }}
        >
          Fecha de Actualización
        </InputLabel>
        <Datetime
          timeFormat={timeFormat}
          dateFormat={'DD/MM/YYYY'}
          closeOnSelect={true}
          helpText={helpText || ''}
          error={error || false}
          inputProps={{
            required: required,
            disabled:
              disabled
          }}
          locale="es-ES"
          isValidDate={ valid }
          {...bindDateValue('fecha_actualizacion')}
        />
      </>
    );
  };

  const campoTipoDocumento = ({nombreCampo, error} = {}) => {
    return (
      <FormControl
        className={classes.formControl}
        fullWidth={true}
        required={true}
      >
        <InputLabel htmlFor={nombreCampo}>Tipo Documento</InputLabel>
        <Select
          native
          name={nombreCampo}
          className={classes.selectEmpty}
          error={error || false}
          {...bindValue(nombreCampo)}
          inputProps={{
            id: nombreCampo,
          }}
          MenuProps={{
            className: classes.selectMenu,
          }}
        >
          <option>Seleccione</option>
          {gatewayConfig.tiposDocumento &&
            gatewayConfig.tiposDocumento.map((td, index) => (
              <option
                key={`${td.id.toString()}${index}`}
                value={td.id}
                //onSelect={() => this.onSelectTipoDocumento(td)}
              >
                {td.name}
              </option>
            ))}
        </Select>
      </FormControl>
    );
  };

  const campoNumeroDocumento = ({nombreCampo, helpText, error, required, disabled } = {}) => {
    return (
      <CustomInput
        id={nombreCampo}
        labelText="Número"
        helpText={helpText}
        error={error}
        formControlProps={{ required: required, fullWidth: true }}
        inputProps={{
          disabled: disabled,
          required: required,
          type: 'text',
          ...bindValue(nombreCampo),
        }}
      />
    );
  };

  const campoImporte = ({helpText, error, required, disabled,
    value = 0} = {}) => {
    return (
      <CustomInput
        id="importe"
        labelText="Importe"
        formControlProps={{ fullWidth: true }}
        helpText={errores?.importe || ''}
        error={errores?.importe || false}
        inputProps={{
          required: true,
          disabled: true,
          type: 'text',
          value: formatMoneda(importe),
          startAdornment: (
            <InputAdornment position="start">$</InputAdornment>
          ),
        }}
      />
    );
  };

  const renderFormTarjeta = () =>  {
    return (
      <>
        <form className={classes.root} autoComplete="off" id="pay" name="pay">
          <Grid container>
            <GridItem xs={12} sm={3}>
              {
                campoTipoDocumento({
                  nombreCampo: 'docType',
                  error: errores?.docType || false,
                })
              }
            </GridItem>
            <GridItem xs={12} sm={3}>
              {
                campoNumeroDocumento({
                  nombreCampo: 'docNumber',
                  error: errores?.docNumber || false,
                  helpText: errores?.docNumber || '',
                  required: true,
                  disabled: false,
                })
              }
            </GridItem>
          </Grid>

          <Grid container>
            <GridItem xs={12} sm={6}>
              <CustomInput
                id="email"
                labelText="E-Mail"
                helpText={errores?.email || ''}
                error={errores?.email || false}
                formControlProps={{ required: true, fullWidth: true }}
                inputProps={{
                  disabled: true,
                  required: true,
                  type: 'email',
                  ...bindValue('email'),
                }}
              />
            </GridItem>
          </Grid>

          <Grid container>
            <GridItem xs={12} sm={6}>
              <CustomInput
                labelText="Número de Tarjeta"
                id="cardNumber"
                helpText={errores?.cardNumber || ''}
                error={errores?.cardNumber || false}
                formControlProps={{ required: true, fullWidth: true }}
                inputProps={{
                  required: true,
                  type: 'cardNumber',
                  disabled: false,
                  onKeyUp: getMetodoPago,
                  onPaste: getMetodoPago,
                  placeholder: '0000 0000 0000 0000',
                  //onPaste: false,onCopy:false, onCut:false, onDrag:false, onDrop:false, autoComplete:"off",
                  ...bindValue('cardNumber'),
                }}
              />
            </GridItem>
          </Grid>

          <Grid container>
            <GridItem xs={12} sm={6}>
              <CustomInput
                id="cardholderName"
                labelText="Nombre del titular"
                helpText={errores?.cardholderName || ''}
                error={errores?.cardholderName || false}
                formControlProps={{ fullWidth: true, required: true }}
                inputProps={{
                  required: true,
                  type: 'text',
                  ...bindValue('cardholderName'),
                }}
              />
            </GridItem>
          </Grid>

          <Grid container>
            <GridItem xs={4} sm={2}>
              <CustomInput
                id="cardExpirationMonth"
                labelText="Mes Exp."
                helpText={errores?.cardExpirationMonth || ''}
                error={errores?.cardExpirationMonth || false}
                formControlProps={{
                  required: true,
                  fullWidth: true,
                  margin: 'none',
                }}
                inputProps={{
                  placeholder: 'MM',
                  required: true,
                  type: 'text',
                  //onPaste: false, onCopy:false, onCut:false, onDrag:false, onDrop:false, autoComplete:"off",
                  ...bindValue('cardExpirationMonth'),
                }}
                inputHtmlProps={{
                  minLength: 2,
                  maxLength: 2,
                  required: true,
                }}
              />
            </GridItem>

            <GridItem xs={4} sm={2}>
              <CustomInput
                id="cardExpirationYear"
                labelText="Año Exp."
                helpText={errores?.cardExpirationYear || ''}
                error={errores?.cardExpirationYear || false}
                formControlProps={{ required: true, fullWidth: true }}
                inputProps={{
                  placeholder: 'YY',
                  required: true,
                  type: 'text',
                  //onPaste: false, onCopy:false, onCut:false, onDrag:false, onDrop:false, autoComplete:"off",
                  ...bindValue('cardExpirationYear'),
                }}
                inputHtmlProps={{ minLength: 2, maxLength: 2 }}
              />
            </GridItem>

            <GridItem xs={4} sm={2}>
              <CustomInput
                id="securityCode"
                labelText="CVV"
                helpText={errores?.securityCode || ''}
                error={errores?.securityCode || false}
                formControlProps={{
                  required: true,
                  fullWidth: true,
                }}
                inputProps={{
                  required: true,
                  type: 'text',
                  //onPaste: false, onCopy:false, onCut:false, onDrag:false, onDrop:false, autoComplete:"off",
                  ...bindValue('securityCode'),
                }}
                inputHtmlProps={
                  {
                    //minLength:medioPago.parametros.formato_cvv.length,
                    //maxLength:medioPago.parametros.formato_cvv.length,
                  }
                }
              />
            </GridItem>
          </Grid>

          <Grid container>
            <GridItem xs={4} sm={2}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
            </GridItem>
            <GridItem xs={8} sm={4}>
              <FormControl
                className={classes.formControl}
                fullWidth={true}
                required={true}
              >
                <InputLabel htmlFor="installments">Cuotas</InputLabel>
                <Select
                  native
                  name="installments"
                  className={classes.selectEmpty}
                  helpText={errores?.installments || ''}
                  error={errores?.installments || false}
                  {...bindValue('installments')}
                  inputProps={{
                    id: 'installments', //autoFocus:true
                    required: false,
                  }}
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                >
                  <option>Seleccione</option>
                  {opcionesCuotas &&
                    opcionesCuotas.map((cuotas, index) =>
                      (<option key={index} value={cuotas.installments}>
                          {cuotas.recommended_message}
                        </option>))
                    }
                </Select>
              </FormControl>
            </GridItem>
          </Grid>
          <Grid container>
            <GridItem xs={6} sm={3}>
              <CustomInput
                id="street_name"
                labelText="Calle"
                formControlProps={{ fullWidth: false }}
                helpText="Dirección destino del resumen de Tarjeta"
                error={false}
                inputProps={{
                  required: false,
                  disabled: false,
                  type: 'text',
                  value: '',
                  startAdornment: '',
                  ...bindValue('street_name'),
                }}
              />
            </GridItem>
            <GridItem xs={3} sm={1}>
              <CustomInput
                id="street_number"
                labelText="Nro"
                helpText=""
                error=""
                formControlProps={{
                  required: false,
                  fullWidth: false,
                }}
                inputProps={{
                  required: false,
                  type: 'text',
                  //onPaste: false, onCopy:false, onCut:false, onDrag:false, onDrop:false, autoComplete:"off",
                  ...bindValue('street_number'),
                }}
                inputHtmlProps={
                  {
                    //minLength:medioPago.parametros.formato_cvv.length,
                    //maxLength:medioPago.parametros.formato_cvv.length,
                  }
                }
              />
            </GridItem>
            <GridItem xs={3} sm={1}>
              <CustomInput
                id="zip_code"
                labelText="CP"
                helpText=""
                error=""
                formControlProps={{
                  required: false,
                  fullWidth: false,
                }}
                inputProps={{
                  required: false,
                  type: 'text',
                  //onPaste: false, onCopy:false, onCut:false, onDrag:false, onDrop:false, autoComplete:"off",
                  ...bindValue('zip_code'),
                }}
                inputHtmlProps={
                  {
                    //minLength:medioPago.parametros.formato_cvv.length,
                    //maxLength:medioPago.parametros.formato_cvv.length,
                  }
                }
              />
            </GridItem>
          </Grid>

          {renderBotonera()}
        </form>
      </>
    );
  }

  const renderFormFecha = () => {
    const isPagos360 = medioPago.clase === MEDIOS_PAGO.PAGOS360;
    let botonPago = null;
    switch (medioPago.clase) {
      case MEDIOS_PAGO.SUPERVIELLE:
        botonPago = (
          <Link
            className={classes.linkPagar}
            href={paymentSupervielle?.rta?.['AccessLink']}
          >
            PAGAR
          </Link>
        );
        break;
      case MEDIOS_PAGO.BPN:
        botonPago = (
          <Link
            className={classes.linkPagar}
            href={paymentBPN?.data?.links?.[0].checkout}
          >
            PAGAR
          </Link>
        );
        break;
      default:
        botonPago = (
        <Button
          disabled={!isPagos360 && disablePagar}
          variant="contained"
          color="primary"
          id={`${medioPago.clase}-pay-button`}
          className="boton_pagar"
          fullWidth={true}
          onClick={
            () => isPagos360
            ? setOpenModal(true)
            : handlerPagar({
              id_operacion: id_operacion,
              medio_pago: medioPago.cod_medio_pago,
            }) }
          >
          {
            isPagos360 ? 'PAGAR' :
            medioPago.clase === MEDIOS_PAGO.LINK ? 'ENVIAR' : 'DESCARGAR'
          }
          </Button>
      )
        break;
    }

    if(botonPago === null) {
      onVolver();
    }

    return (
      <>
        <form className={classes.root} autoComplete="off" id="pay" name="pay">
          <Grid container>
            <GridItem xs={12} sm={6}>
            {
              campoFecha({
                helpText: errores?.fecha_actualizacion,
                error: errores?.fecha_actualizacion,
                disabled: medioPago.actualiza_fecha !== 'S',
                required: true,
              })
            }
            </GridItem>
            <GridItem xs={12} sm={6}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
            </GridItem>
          </Grid>

          <Grid container>
            <GridItem xs={6} sm={3}>
              <FormControl fullWidth={true}>
                { botonPago }
              </FormControl>
            </GridItem>
            <GridItem xs={6} sm={3}>
              <FormControl fullWidth={true}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth={true}
                  onClick={onVolver}
                >
                  VOLVER
                </Button>
              </FormControl>
            </GridItem>
          </Grid>
        </form>
      </>
    );
  };

  const renderFormMacroClick = () => {
    return (
      <>
        <Grid container>
          <GridItem xs={12} sm={6}>
            {
              campoFecha({
                helpText: errores?.fecha_actualizacion,
                error: errores?.fecha_actualizacion,
                disabled: true,
                required: true,
              })
            }
          </GridItem>
          <GridItem xs={12} sm={6}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
          </GridItem>
        </Grid>
        <form
          className={classes.root}
          method={'post'}
          action={paymentMacroClick.url_servicio}
          autoComplete="off"
          id="pay"
          name="pay"
        >
          <Grid container>
            <input
              type="hidden"
              name="CallbackSuccess"
              value={paymentMacroClick.callbackEncriptada}
            />
            <input
              type="hidden"
              name="CallbackCancel"
              value={paymentMacroClick.cancelEncriptada}
            />
            <input
              type="hidden"
              name="CallbackPending"
              value={paymentMacroClick.pendingEncriptada}
            />
            <input
              type="hidden"
              name="Comercio"
              value={paymentMacroClick.comercio}
            />
            <input
              type="hidden"
              name="SucursalComercio"
              value={paymentMacroClick.sucursalEncriptada}
            />
            <input
              type="hidden"
              name="hash"
              value={paymentMacroClick.hash_value}
            />
            <input
              type="hidden"
              name="TransaccionComercioId"
              value={paymentMacroClick.id}
            />
            <input
              type="hidden"
              name="monto"
              value={paymentMacroClick.montoEncriptado}
            />
            {paymentMacroClick.items.map((item, i) => (
              <input
                type="hidden"
                name={`Producto[${i}]`}
                value={item.description}
                key={i}
              />
            ))}
          </Grid>
          <Grid container>
            <GridItem xs={6} sm={3}>
              <FormControl fullWidth={true}>
                <Button
                  variant="contained"
                  color="primary"
                  id="macrolcik-pay-button"
                  className="boton_pagar"
                  fullWidth={true}
                  type="submit"
                  onClick={() =>
                    setLoading(true)
                  }
                >
                  PAGAR
                </Button>
              </FormControl>
            </GridItem>
            <GridItem xs={6} sm={3}>
              <FormControl fullWidth={true}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth={true}
                  onClick={onVolver}
                >
                  VOLVER
                </Button>
              </FormControl>
            </GridItem>
          </Grid>
        </form>
      </>
    );
  };

  const renderFormMercadoPago = () => {
    return (
      <>
        <Grid container>
          <GridItem xs={12} sm={6}>
            {
              campoFecha({
                helpText: errores?.fecha_actualizacion,
                error: errores?.fecha_actualizacion,
                disabled: false,
                required: true,
              })
            }
          </GridItem>
          <GridItem xs={12} sm={6}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
          </GridItem>
          <GridItem xs={6} sm={3}>
            <a
              href={paymentMercadoPago.init_point}
              data-preference-id={paymentMercadoPago.id}
            >
              <Button
                variant="contained"
                color="primary"
                id="mercadopago-pay-button"
                className="boton_pagar"
                fullWidth={true}
              >
                PAGAR
              </Button>
            </a>
          </GridItem>
        </Grid>
      </>
    );
  };

  const renderFormPagosTic = () => {
    return (
      <>
        <Grid container>
          <GridItem xs={12} sm={6}>
            {
              campoFecha({
                helpText: errores?.fecha_actualizacion,
                error: errores?.fecha_actualizacion,
                disabled: true,
                required: true,
              })
            }
          </GridItem>
          <GridItem xs={12} sm={6}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
          </GridItem>
        </Grid>
        <Grid container>
          <GridItem xs={6} sm={3}>
            <FormControl fullWidth={true}>
              <a
                href={paymentPagosTic.form_url}
                style={{ textDecoration: 'none', color: 'white' }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  id="pagostic-pay-button"
                  className="boton_pagar"
                  fullWidth={true}
                >
                  PAGAR
                </Button>
              </a>
            </FormControl>
          </GridItem>
          <GridItem xs={6} sm={3}>
            <FormControl fullWidth={true}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth={true}
                onClick={onVolver}
              >
                VOLVER
              </Button>
            </FormControl>
          </GridItem>
        </Grid>
      </>
    );
  };

  const renderFormEpagos = () => {
    return (
      <>
        <Grid container>
          <GridItem xs={12} sm={6}>
            {
              campoFecha({
                helpText: errores?.fecha_actualizacion,
                error: errores?.fecha_actualizacion,
                disabled: medioPago.actualiza_fecha !== 'S',
                required: true,
              })
            }
          </GridItem>
          <GridItem xs={12} sm={6}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
          </GridItem>
        </Grid>
        <Grid container>
          <GridItem xs={6} sm={3}>
            <div id="elementoEpagos" className={classes.divEpagos}></div>
          </GridItem>

          <GridItem xs={6} sm={3}>
            <FormControl fullWidth={true}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth={true}
                onClick={onVolver}
              >
                VOLVER
              </Button>
            </FormControl>
          </GridItem>
        </Grid>
      </>
    );
  };

  const handleRedirect = (e) => {
    e.target.contentDocument
      ? setShowButtonClose(false)
      : setShowButtonClose(true)
  };


  const renderBotonera = () => {
    return (
      <Grid container>
        <GridItem xs={6} sm={3}>
          <FormControl fullWidth={true}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth={true}
              size="lg"
              onClick={onVolver}
            >
              VOLVER
            </Button>
          </FormControl>
        </GridItem>

        <GridItem xs={6} sm={3}>
          <FormControl fullWidth={true}>
            <Button
              disabled={ medioPago.clase === 'interbanking' ?
                !formData['customer_cuit_number']
                  || !formData['customer_cuit_number'].match(/^\d{11}$/)
                : disablePagar
              }
              variant="contained"
              color="primary"
              fullWidth={true}
              size="lg"
              onClick={(e) => onSubmit(e) }
            >
              {medioPago.clase === 'interbanking'  ? 'ENVIAR' :  'PAGAR' }
            </Button>
          </FormControl>
        </GridItem>
      </Grid>
    );
  };

  const renderFormBanelco = () => {
    return (
      <form
        autoComplete="off"
        className={classes.root}
        action=""
        method="post"
        id="formulario"
      >
        <Grid container>
          <GridItem xs={12} sm={3}>
              {
                campoTipoDocumento({
                  nombreCampo: 'customer_doc_type',
                  error: errores?.customer_doc_type || false,
                })
              }
          </GridItem>
          <GridItem xs={12} sm={3}>
              {
                campoNumeroDocumento({
                  nombreCampo: 'customer_doc_number',
                  error: errores?.customer_doc_number || false,
                  helpText: errores?.customer_doc_number || '',
                  required: true,
                  disabled: false,
                })
              }
          </GridItem>
        </Grid>

        <Grid container>
          <GridItem xs={12} sm={6}>
            <CustomInput
              labelText="Nombre del titular"
              id="customer_name"
              helpText={errores?.customer_name || ''}
              error={errores?.customer_name || false}
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                placeholder: 'TITULAR',
                required: true,
                type: 'text',
                ...bindValue('customer_name'),
              }}
            />
          </GridItem>
        </Grid>

        <Grid container>
          <GridItem xs={12} sm={6}>
            {
              campoFecha({
                helpText: errores?.fecha_actualizacion,
                error: errores?.fecha_actualizacion,
                disabled: medioPago.actualiza_fecha !== 'S',
                required: true,
              })
            }
          </GridItem>
          <GridItem xs={12} sm={6}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
          </GridItem>
        </Grid>
        {renderBotonera()}
      </form>
    );
  };

  const renderFormInterbanking = () => {
    return (
      <form
        autoComplete="off"
        className={classes.root}
        action=""
        method="post"
        id="formulario"
      >
        <Grid container>
          <GridItem xs={12} sm={3}>
            <FormControl
              className={classes.formControl}
              fullWidth={true}
              required={true}
            >
              <InputLabel htmlFor="customer_doc_type">
                CUIT
              </InputLabel>
            </FormControl>
          </GridItem>

          <GridItem xs={12} sm={3}>
            <CustomInput
              id="customer_cuit_number"
              labelText="CUIT: 11 dígitos sin guiones"
              helpText={errores?.customer_doc_number || ''}
              error={errores?.customer_doc_number || false}
              formControlProps={{ required: true, fullWidth: true }}
              inputProps={{
                disabled: false,
                required: true,
                type: 'text',
                ...bindValue('customer_cuit_number'),
              }}
            />
          </GridItem>
        </Grid>

        <Grid container>
          <GridItem xs={12} sm={6}>
            <CustomInput
              labelText="Razón Social"
              id="customer_name"
              helpText={errores?.customer_name || ''}
              error={errores?.customer_name || false}
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                placeholder: 'Razón Social del TITULAR',
                required: true,
                type: 'text',
                ...bindValue('customer_name'),
              }}
            />
          </GridItem>
        </Grid>

        <Grid container>
          <GridItem xs={12} sm={6}>
            {
              campoFecha({
                helpText: errores?.fecha_actualizacion,
                error: errores?.fecha_actualizacion,
                disabled: medioPago.actualiza_fecha !== 'S',
                required: true,
              })
            }
          </GridItem>
          <GridItem xs={12} sm={6}>
              {
                campoImporte({
                  helpText: errores?.importe || '',
                  error: errores?.importe || false,
                  required: true,
                  disabled: true,
                  value: formatMoneda(importe),
                })
              }
          </GridItem>
        </Grid>
        {renderBotonera()}
      </form>
    );
  };

  let contenidoFormulario = null;
  switch (medioPago.formulario) {
    case 'decidir_banelco':
      contenidoFormulario = renderFormBanelco();
      break;
    case 'interbanking' :
      contenidoFormulario = renderFormInterbanking();
      break;
    case 'decidir_tarjeta' :
      contenidoFormulario = renderFormTarjeta();
      break;
    case 'mercadopago_tarjeta' :
      contenidoFormulario = renderFormTarjeta();
      break;
    case 'no_form' :
      if(medioPago.actualiza_fecha) contenidoFormulario = renderFormFecha();
      break;
    case 'pagos360' :
      if(medioPago.actualiza_fecha) contenidoFormulario = renderFormFecha();
      break;
    case 'superville' :
      if(medioPago.actualiza_fecha) contenidoFormulario = renderFormFecha();
      break;
    case 'bpn' :
      if(medioPago.actualiza_fecha) contenidoFormulario = renderFormFecha();
      break;
    case 'mercadopago' :
      contenidoFormulario = renderFormMercadoPago();
      break;
    case 'macroclick' :
      contenidoFormulario = renderFormMacroClick();
      break;
    case 'pagostic' :
      contenidoFormulario = renderFormPagosTic();
      break;
    case 'epagos' :
      contenidoFormulario = renderFormEpagos();
      break;
  }

  if(contenidoFormulario === null) {
    contenidoFormulario = (
      <>
        <Typography gutterBottom variant="h5">
          Gateway de pago no disponible.
        </Typography>
        <Button
        variant="contained"
        color="secondary"
        fullWidth={false}
        onClick={onVolver}
        >
          Volver
        </Button>
      </>
    );
  }

  return (
    <Grid ref={rootRef}>
      <BlockComponent blocking={loading}>
      </BlockComponent>
        { contenidoFormulario }
      <MessageComponent {...message} />
      {openModal && (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          style={ {
            width: '98%',
            height: '98%',
            top: '1%',
            left: '1%',
            right: 'auto',
            bottom: 'auto',
          }}
        >
          <div
            style={{
                width: '98%',
                height: '98%',
                top: '1%',
                left: '1%',
                right: 'auto',
                bottom: 'auto',
            }}
            >
            <iframe
              id={`${medioPago.clase}-modal-popbox`}
              src={payment360?.checkout_url}
              onLoad={(e) => handleRedirect(e)}
              referrerPolicy="origin-when-cross-origin"
              allowpaymentrequest="true"
              sandbox="allow-forms
                  allow-pointer-lock
                  allow-same-origin
                  allow-scripts
                  allow-top-navigation
                  allow-downloads
                  allow-popups"
                style={{
                  height: '90%',
                  width: '98%',
                  display: 'flex',
                }}

            />
            {showButtonClose && (
              <Button
                variant="contained"
                color="primary"
                fullWidth={true}
                size="lg"
                onClick={(e) => setOpenModal(false)}
                style={{
                  height: '30px',
                  display: 'flex',
                }}
              >
                CERRAR
              </Button>
            )}
          </div>
        </Modal>
      )}
    </Grid>
  );
}

export default withStyles(styles)(VerGateway);
